/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Online_User_GuideInputs */



/**
* | output |
* | --- |
* | "Online User Guide" |
*
* @param {Online_User_GuideInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const online_user_guide = /** @type {((inputs?: Online_User_GuideInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Online_User_GuideInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Guide de l'utilisateur en ligne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Online-Benutzerhandbuch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Guida utente online")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Онлайн-руководство пользователя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Guía del usuario en línea")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在线用户指南")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オンラインユーザーガイド")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑनलाइन उपयोगकर्ता मार्गदर्शिका")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Guia do usuário online")
	return /** @type {LocalizedString} */ ("Online User Guide")
});